import React from 'react';
import {Empty as AntEmpty} from 'antd';
import i18n from './../../../../../constants/initLng';

const Empty = (props) => {
    return (
        <AntEmpty {...props} description={i18n.t('action.noData')} className={`hms-empty ${props.className}`}>{props.children}</AntEmpty>
    )
}
export default Empty;
export const PRESENTED_IMAGE_SIMPLE = AntEmpty.PRESENTED_IMAGE_SIMPLE;
export const PRESENTED_IMAGE_DEFAULT = AntEmpty.PRESENTED_IMAGE_DEFAULT;